import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

export interface VersionConflictDialogData {
  /** Optional override for the body copy (defaults to the standard reload-and-reapply message). */
  message?: string;
}

/**
 * Shown when a user-edit save is rejected because the record was changed by
 * someone else since it was loaded (a `409` version conflict). Shared by the
 * vendor's self-service profile page and the internal user-management
 * console — both save the same underlying user record, so both can hit the
 * same conflict and want the same recovery: acknowledge, then reload the
 * current data before re-applying the edit. `disableClose` on the caller's
 * `open()` keeps this to its one action — there is nothing useful to do with
 * a stale save other than start over from the current record.
 */
@Component({
  standalone: true,
  selector: 'app-version-conflict-dialog',
  imports: [CommonModule, MatDialogModule, MatButtonModule],
  templateUrl: './version-conflict-dialog.component.html',
  styleUrl: './version-conflict-dialog.component.scss',
})
export class VersionConflictDialogComponent {
  constructor(
    private dialogRef: MatDialogRef<VersionConflictDialogComponent, boolean>,
    @Inject(MAT_DIALOG_DATA) public data: VersionConflictDialogData,
  ) {}

  onReload(): void {
    this.dialogRef.close(true);
  }
}
